export const BUTTON_THEMES = {
  default: {
    bg: 'bg-white/80 hover:bg-white',
    text: 'text-gray-600',
    border: 'border-gray-300'
  },
  blue: {
    bg: 'bg-blue-200 hover:bg-blue-300',
    text: 'text-blue-700',
    border: 'border-blue-300'
  },
  green: {
    bg: 'bg-green-200 hover:bg-green-300',
    text: 'text-green-700',
    border: 'border-green-300'
  },
  emerald: {
    bg: 'bg-emerald-200 hover:bg-emerald-300',
    text: 'text-emerald-700',
    border: 'border-emerald-300'
  },
  terminal: {
    bg: 'bg-gray-700 hover:bg-gray-600',
    text: 'text-green-400',
    border: 'border-gray-600'
  }
};

export const PANEL_THEMES = {
  analysis: {
    background: 'bg-blue-50',
    header: 'bg-blue-100',
    title: 'text-blue-800',
    icon: '📊'
  },
  testcases: {
    background: 'bg-green-50',
    header: 'bg-green-100',
    title: 'text-green-800',
    icon: '📝'
  },
  robot: {
    background: 'bg-gray-900',
    header: 'bg-gray-800',
    title: 'text-white',
    icon: '🤖'
  }
};